import React from 'react';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

const Audit = () => <>Audit</>;

export default withDashboardSidebar(Audit);
